import React, { useCallback, useMemo } from 'react'
// @ts-ignore no types
import { debounce } from 'lodash'
// @ts-ignore no types
import { connect } from 'react-redux'
// @ts-ignore no types
import classnames from 'classnames/bind'
// @ts-ignore no types
import { Text, Icon, Grid, Button, Property } from '@adc/ui-adc'
import type { primitives } from '@adc/blueprint'
import { usePropertyContext } from '../../context/property'
import { getInitMarketingData } from '../../utils/headers'
import { useListingContext } from '../../context/listing'
import SectionPanel from '../../components/sectionPanel'
import { formatNumber } from '../../utils/formatters'
import { withModalHooks } from '../../hooks/useModalFeatures'
import { withNudgeHook } from '../../hooks/useNudgesFeatures'
import { toggleOptinModal } from '../../actions/modals'
import AssetType from './assetType'
// @ts-ignore no types
import styles from './index.scss'

const cx = classnames.bind(styles)
const elmId = 'property_header'

interface PropertyHeaderProps {
  buyerViews?: number
  toggleSaveProperty: (saveData: any) => void
  featureFlags: any
  user: primitives.AuctionUser
  pushAuthQueueItem: () => void
  pushOnboardingQueueItem: () => void
  toggleAuthModal: () => void
  nudgeOptInModal?: () => void
}

const PropertyHeader = ({
  buyerViews = 0,
  featureFlags,
  user,
  pushAuthQueueItem,
  pushOnboardingQueueItem,
  toggleAuthModal,
  nudgeOptInModal = () => {},
}: PropertyHeaderProps) => {
  const { listing } = useListingContext()
  const { property, propertyActions } = usePropertyContext()
  const isPropertySaved = property.is_currently_saved

  const debounceOnSave = useCallback(
    debounce(async () => {
      await propertyActions?.toggleSaveProperty({
        listing,
        property,
        pushAuthQueueItem,
        toggleAuthModal,
        pushOnboardingQueueItem,
        nudgeOptInModal,
      })
    }, 500),
    [
      propertyActions,
      property,
      listing,
      pushAuthQueueItem,
      toggleAuthModal,
      pushOnboardingQueueItem,
      nudgeOptInModal,
    ]
  )

  const saveProperty = () => {
    // @ts-ignore TODO:
    debounceOnSave(property)
  }

  const initMarketingData = getInitMarketingData({ listing, user })

  const bedBaths = useMemo(
    () =>
      [
        [listing.primary_property?.summary?.total_bedrooms, 'Beds'],
        [listing.primary_property?.summary?.total_bathrooms, 'Baths'],
        [
          formatNumber(listing.primary_property?.summary?.living_size),
          'Sq. Ft.',
        ],
      ].map(([val, unit]) => (
        <span className={cx('bed-baths-separation')} key={unit}>
          <span className={cx('value')}>{val || ' - '}</span>{' '}
          <span className={cx('unit')}>{unit}</span>
        </span>
      )),
    [
      listing.primary_property?.summary?.total_bedrooms,
      listing.primary_property?.summary?.total_bathrooms,
      listing.primary_property?.summary?.living_size,
    ]
  )

  const { test, icon } = featureFlags['fe.resi.ab.testing.pdp.save.icon'] || {
    test: { version: '' },
    icon: { color: 'info' },
  }

  return (
    <SectionPanel compact collapsible={false} elmId='address'>
      <script dangerouslySetInnerHTML={{ __html: initMarketingData }} />
      <div
        data-ad-space={`PDP_TOP_${listing.auction?.is_online ? 'REO' : 'TPS'}`}
        className='u-text-center u-pb-2'
      />
      <div className='u-pb-1'>
        <Grid verticalAlign='middle'>
          <Grid.Row>
            <Grid.Column computer={10} tablet={8} mobile={16}>
              <AssetType listing={listing} showTutorial />
              <Text.Header
                as='h1'
                level='1'
                color='gray'
                weight='normal'
                compact
                data-elm-id={`${elmId}_address`}
              >
                {listing.formatted_address?.[0]}
                <div className={cx('spacer')} />
                <Text.Header
                  as='span'
                  level='3'
                  color='gray'
                  weight='normal'
                  compact
                  data-elm-id={`${elmId}_location`}
                >
                  {listing.formatted_address?.[1]}
                </Text.Header>
              </Text.Header>
            </Grid.Column>
            <Grid.Column computer={6} tablet={8} mobile={16}>
              <div
                className={cx(
                  'u-display-f',
                  'u-display-f-vcenter',
                  'u-text-center',
                  'u-display-f-end'
                )}
              >
                {buyerViews && buyerViews >= 10 && (
                  <Text
                    data-elm-id={`${elmId}_views`}
                    className={cx('u-nowrap')}
                  >
                    <Icon name='user outline' />
                    {formatNumber(buyerViews)} Views
                  </Text>
                )}
                <Button
                  className={cx(
                    'no-border-button',
                    'save-button',
                    test?.version
                  )}
                  role='secondary'
                  tag='a'
                  onClick={saveProperty}
                  elmId={`${elmId}_save_button`}
                >
                  <Icon
                    name='heart'
                    iconStyle={isPropertySaved ? 'solid' : 'regular'}
                    color={icon?.color || 'info'}
                  />{' '}
                  {isPropertySaved ? 'Saved' : 'Save'}
                </Button>
              </div>
              {bedBaths && (
                <div className={cx('u-text-right')}>
                  <Text>{bedBaths}</Text>
                </div>
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    </SectionPanel>
  )
}

const mapStateToProps = (store: any) => ({
  buyerViews: store.propertyAnalytics.propertyViews,
  user: store.user,
  featureFlags: store.featureFlags,
})

const mapDispatchToProps = (dispatch: any) => ({
  openOptInModal: () => dispatch(toggleOptinModal(true)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNudgeHook(withModalHooks(PropertyHeader)))
